import produce from 'immer';
import './types';
import {
    SET_SEASON_HIGHS,
    SET_ROUND_HIGHS
} from '../actions';

/**
 * @type {LastRoundHighsState}
 */
const initialState = {
    roundData: null,
    seasonData: null
};

/**
 * @param {LastRoundHighsState} state - The Redux state.
 * @param {LastRoundHighsActions} action - The Redux action.
 * @return {LastRoundHighsState} The updated Redux state.
 */
export const lastRoundHighsReducer = ( state = initialState, action ) => {
    return produce( state, draft => {
        switch ( action.type ) {
            case SET_ROUND_HIGHS:
                draft.roundData = action.payload;
                break;
            case SET_SEASON_HIGHS:
                draft.seasonData = action.payload;
                break;
            default:
                draft;
        }
    } );
};